import React, {forwardRef, useImperativeHandle, useState} from 'react';
import FlexMainWrapper from '../../designComponents/wrappers/FlexMainWrapper';

import {InputLine} from '../../designComponents/inputs/InputLine';
import {SText} from '../../designComponents/text/ContentText';

const TypeComponent = forwardRef(({ types }, _ref) => {
    const [param, setParam] = useState({});

    useImperativeHandle(_ref, () => ({
        paramsData: param,
    }));

    return (
        <FlexMainWrapper style={{ flexDirection: 'column', gap: 0 }}>
            {Object.keys(types).map((key, index) => {
                return (
                    <FlexMainWrapper key={`params_${key}_${index}`} style={{ flexDirection: 'column', width: '100%' }}>
                        {types[key].description ? <SText text={types[key].description} /> : null}
                        <InputLine
                            wrapperStyle={{ margin: '5px 0', width: '100%' }}
                            inputStyle={{ width: '200px' }}
                            titleStyle={{ width: '97px', fontWeight: 'bold' }}
                            title={types[key].label}
                            value={param[key]}
                            placeholder={types[key].label}
                            onChange={(e) => {
                                let obj = { ...param };
                                obj[key] = e.target.value;
                                setParam(obj);
                            }}
                        />
                        {types[key].description ? <SText text={types.description} /> : null}
                    </FlexMainWrapper>
                );
            })}
        </FlexMainWrapper>
    );
});

export default TypeComponent;
